import { type Theme } from '#app/theme/index.js';
import { type ProjectCoverTextCoverStyle } from './types.js';
import { getBackgroundStyles } from './utils/getBackgroundStyles.js';
import { css, styled } from 'styled-components';

const getCoverStyles = ({
  textCoverStyle,
  theme,
}: {
  textCoverStyle?: null | ProjectCoverTextCoverStyle;
  theme: Theme;
}) => {
  const { image } = getBackgroundStyles(theme, textCoverStyle);
  const backgroundImage = `url(${image})`;

  return css`
    background-image: ${backgroundImage};
  `;
};

export const Cover = styled.div<{
  textCoverStyle?: null | ProjectCoverTextCoverStyle;
}>`
  ${({ textCoverStyle, theme }) => css`
    position: absolute;
    // We need to keep both inset and top,left,right,bottom to 0 here
    // Safari doesn't play well with inset 🙄
    inset: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
    border-radius: inherit;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    ${getCoverStyles({ textCoverStyle, theme })}
  `}
`;
